module.exports = __webpack_public_path__ + "media/ravepigmegamix.5c658fd1.wav";